import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as rxjs from 'rxjs'

import * as routeBound from '../../../route-bound'
import * as clusters from '../clusters'

import { Api } from './api.service'
import * as effects from './effects'
import * as plugins from './plugins'
import type { TypeParams } from './types'

/**
 * Provides the list of space records that can still be added to the current
 * cluster (i.e. records that belong to the cluster's department but are not
 * yet assigned). Kept separate from the assigned-records collection so their
 * filter/selection state never interfere with each other.
 */
@ngCore.Injectable()
export class Collection extends ec.Collection<TypeParams> {
  constructor() {
    const scenarioContext = ngCore.inject(routeBound.scenario.Context.TOKEN)
    const clustersEc = ngCore.inject(clusters.Collection)

    super({
      api: ngCore.inject(Api),
      context$: rxjs
        .combineLatest([
          scenarioContext,
          clustersEc.plugins.currentEntityPlugin.feature.selectors.getId()
            .asObservable,
        ])
        .pipe(
          rxjs.map(([context, clusterId]) => {
            if (!context || !ents.extra.space.Cluster.Id.isId(clusterId)) {
              return undefined
            }
            return { ...context, clusterId }
          }),
        ),
      identify: record => record.id,
      name: ec.Name.Predefined.SpaceClusterAssignableRecord,
      plugins: {
        additionalFactories: [new plugins.spaceDimensionFilter.Factory()],
      },
    })

    this.feature.registerEffects(
      effects.applyFiltersOnSelection(this),
      effects.resetFiltersOnModalOpen(this),
      effects.releaseSelectionOnModalClose(this),
    )
  }
}
